import { Link } from '@tanstack/react-router';
import { Shield } from 'lucide-react';
import { WorkspaceButton } from '@/components/ui/workspace';
import { useSignoffQuery } from '@/lib/api/requirements-signoff';
import { signoffHeadline } from './signoff-logic';

/**
 * "Sign-off · <state>" in the Selection → Requirements header (Decision
 * 54.40; prototype `requirementsView` header). Shown only when the
 * engagement has sign-off, that is with Discovery on: the API answers
 * not_found otherwise, and the button stays away.
 */
export function SignoffHeaderLink({ engagementId }: { engagementId: string }) {
  const q = useSignoffQuery(engagementId);
  if (!q.data) return null;
  return (
    <WorkspaceButton size="md" asChild>
      <Link
        to="/engagements/$engagementId/discovery/signoff"
        params={{ engagementId }}
        title="Requirements sign-off by the client"
      >
        <Shield className="h-3.5 w-3.5" aria-hidden="true" />
        Sign-off · {signoffHeadline(q.data).short}
      </Link>
    </WorkspaceButton>
  );
}
